var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.information && _vm.item.information.images)?_c('v-icon',[_vm._v("badge")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }